/* eslint-disable @typescript-eslint/no-explicit-any -- existing annotations; retyping would change compile behavior */
import api from 'api';
import TermsOfUseTemplate from 'components/serviceProviderForms/TermsOfUseTemplate';
import { useEffect, useState } from 'react';

export interface Data {
    firstname: string;
    middlename: string;
    lastname: string;
    email: string;
    phone_number: string;
    password: string;
    repeatPassword: string;
    role: string;
}

export const initData: Data = {
    firstname: '',
    middlename: '',
    lastname: '',
    email: '',
    phone_number: '',
    role: '',
    password: '',
    repeatPassword: '',
};
export default function TermOfUSeInfo() {
    const tableName = 'User';

    const [, setData] = useState<any>();
    const loadData = (data: Data) => {
        data = { ...data, password: '', repeatPassword: '' };
        setData(data);
    };

    useEffect(() => {
        api.tableInput.newFetchCandidateInput(loadData, tableName);
    }, []);

    return (
        <>
            <div>
                <TermsOfUseTemplate />
            </div>
        </>
    );
}
